

















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ExternalReviewListComponent from "./ReviewList/ExternalReviewList.vue";
import ExternalReviewGridComponent from "./ReviewList/ExternalReviewGrid.vue";
import ExternalReviewConsolidatedGridComponent from "./ReviewList/ExternalReviewConsolidatedGrid.vue";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import { ReportFilter, ReportParameter } from "@/entities";

@Component({
  components: {
    ExternalReviewListComponent,
    ExternalReviewGridComponent,
    ExternalReviewConsolidatedGridComponent,
    AdvanceSearchComponent,
  },
})
export default class ExtReviewSubLayoutComponent extends Vue {
  @Prop() filters: any;
  selectedParams: Array<ReportParameter> = [];
  
  @Prop() reviews!: any;
  isTabView: boolean = false;
  tabs = [
    {
      component: "ExternalReviewListComponent",
      text: "Grid View",
      icon: "mdi-format-list-bulleted-square",
    },
    {
      component: "ExternalReviewGridComponent",
      text: "Card View",
      icon: "mdi-view-grid",
    },
  ];
  consolidatedTab = [
    {
      component: "ExternalReviewConsolidatedGridComponent",
      text: "Consolidated View",
      icon: "mdi-format-list-bulleted",
    },
  ];
  currentTab = this.tabs[0];
  previousTab: any;

  mounted() {}

  switchLayout(isTabView) {
    this.isTabView = !isTabView;

    if (this.isTabView) {
      this.currentTab = this.tabs[1];
    } else {
      this.currentTab = this.tabs[0];
    }
  }

  switchToConsolidated() {
    this.previousTab = this.currentTab;
    this.currentTab = this.consolidatedTab[0];
    this.currentTab.text = this.previousTab.text;
    this.currentTab.icon = this.previousTab.icon;
  }

  get currentTabComponent() {
    return this.currentTab.component;
  }

  onSearch(selValue) {
    this.$emit("filterChanged", this.selectedParams);
  }
}
